export default "__VITE_ASSET__DLqYR0mN__"